import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { API_URL } from "../../shared/constant";
import axios from "axios";
import Swal from "sweetalert2";
import Loader from "../../shared/loader";
const Customers = () => {
  const [customerData, setCustomerData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [customerDataOriginal, setCustomerDataOriginal] = useState([]);
  const [loading, setLoading] = useState(true);



  const getCustomer = () => {  
    axios.post(API_URL.CUSTOMERS_LIST, {}).then(
      (res) => {
        if (res.data.status === 1) {
          setCustomerData(res.data.data);
           setCustomerDataOriginal(res.data.data);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,

        });
      }
    );
  };

  const deleteCustomer = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this - " + row.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.CUSTOMERS_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = customerData.filter((r) => r.id !== row.id);
              setCustomerData(newData);
            }
            toast.success(row.name + " Delete Successfully", { autoClose: 3000 });
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

  const approveCustomer = (row, status) => {
    Swal.fire({
      title: (status === 0) ? 'Are you sure to block this user?' : 'Are you sure to approve this?',
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.CUSTOMERS_APPROVE, { id: row.id, status: status }).then(
          (res) => {
            if (res.data.status === 1) {
              let newIndex = customerData.findIndex((r) => r.id === row.id);
              customerData[newIndex].customer_status = status;
              setCustomerData(customerData);
            }
            toast.success(row.name + " approved Successfully", { autoClose: 3000 });
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

const handleSearchChange = async (e) => {
  const value = e.target.value;
  setSearchValue(value);

  if (value.length >= 3) {
    try {
      const res = await axios.post(API_URL.CUSTOMERS_SEARCH, { text: value });

      if (Array.isArray(res.data)) {
        setCustomerData(res.data);
      } else if (Array.isArray(res.data.data)) {
        setCustomerData(res.data.data);
      }
    } catch (error) {
      toast.error("Search failed", { autoClose: 2000 });
    }
  } else {
    setCustomerData(customerDataOriginal);
  }
};


  useEffect(() => {
    getCustomer();
  }, []);

  return (
    <>
      
      <div className="row">
        <div className="col-4">
          <h1>Customers <small className="me-2">({customerData.length})</small></h1>
        </div>
        <div className="col-8">
          <div className="d-flex align-items-center  justify-content-end">
            <div className="col-md-5 mb-0 mr-2">
              <div className="form-group mb-0 mr-2">
                <input
                  type="text"
                  value={searchValue}
                  onChange={handleSearchChange}
                  className="form-control"
                  placeholder="Search by Name ..."
                />
              </div>
            </div>
            <Link to={"/customers/add"} className="btn btn-primary">
              <i className="simple-icon-plus me-2" aria-hidden="true"></i> Add Customer
            </Link>
          </div>
        </div>
        <div className="col-12">
            <div className="pwa-search-section mb-3">
                <div className="input-group">
                <input
                    type="text"
                    value={searchValue}
                    onChange={handleSearchChange}
                    className="form-control form-control-lg"
                    placeholder="Search customers by name..."
                />
                <button className="btn btn-outline-secondary" type="button">
                    <i className="simple-icon-magnifier"></i>
                </button>
                </div>
            </div>
        </div>
        <div className="col-sm-12">
            <div className="card">
              <div className="card-body p-0">
              {loading && <Loader></Loader>}
              {!loading && (
                <div>
                  <div className="table-responsive">
                    <table className="table">
                      <thead className="">
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Contact</th>
                          <th>Location</th>
                          <th
                            className="text-center"
                            style={{ width: "200px" }}
                          >
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {customerData.map((row, key) => {
                          return (
                            <tr key={key}>
                              <td>{key + 1}</td>
                              <td>{row.name}</td>
                              <td>{row.email}</td>
                              <td>{row.contact_no}</td>
                              <td>{row.city_name}, {row.state_name}</td>
                              <td className="d-flex justify-content-center gap-2" style={{ width: "200px" }}>
                                <Link to={"/customers/edit/" + row.id} className="btn btn-sm btn-secondary mr-2">
                                  <i className="fa fa-edit me-1"></i> Edit
                                </Link>
                                {row.customer_status === 0 ? <button onClick={() => approveCustomer(row, 1)} className="btn btn-sm btn-success mr-2">
                                  <i className="fa fa-check me-1"></i> Approve
                                </button> :
                                  <button onClick={() => approveCustomer(row, 0)} className="btn btn-sm btn-danger mr-2">
                                    <i className="fa fa-trash me-1"></i> Block
                                  </button>}
                                <button onClick={() => deleteCustomer(row)} className="btn btn-sm btn-danger">
                                  <i className="fa fa-trash me-1"></i> Delete
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
                </div>
            </div>
        </div>
        </div>
    </>
  );
};

export default Customers;
